<table class="magic_box" [style.height]="computeHeight()" *ngIf="!answer_table">
  <tr *ngFor="let row of exercise_body">
    <td *ngFor="let elem of row">
      {{ elem }}
    </td>
  </tr>
</table>
<div *ngIf="exercise_hint" class="exercise_hint">
    <!--<td class="exercise_hint">-->
      {{ exercise_hint }}
    <!--</td>-->
  </div>
<table class="magic_box_answer" *ngIf="answer_table">
  <tr *ngFor="let row of exercise_body">
    <td *ngFor="let elem of row">
      {{ elem }}
    </td>
  </tr>
</table>
